module.exports = __webpack_public_path__ + "img/icon_route_map.e3122718.svg";